import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { bool, func, shape, arrayOf } from "prop-types";

import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { actions as sessionActions } from "reducers/session";
import { actions as settingsActions, selectors as settingsSelectors } from "reducers/settings";

import Notification from "pages/_components/Notification";
import Step6Content from "pages/login/_components/Step6Content";
import MainContainer from "pages/_components/MainContainer";
import { push } from "connected-react-router";
import I18n from "pages/_components/I18n";

class LoginStep6 extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        dispatch: func.isRequired,
        isMobile: bool.isRequired,
        commissions: shape({}).isRequired,
        documents: arrayOf(shape({})),
    };

    static defaultProps = {
        documents: [],
    };

    componentDidMount() {
        const { dispatch, commissions } = this.props;

        if (!commissions) {
            dispatch(push("/desktop"));
        } else {
            dispatch(settingsActions.loadDocumentsRequest("commissions"));
        }
    }

    onCancel = () => {
        const { dispatch } = this.props;
        dispatch(loginActions.reset());
        dispatch(sessionActions.logout());
        dispatch(push("/"));
    };

    render() {
        const { isDesktop, isMobile, commissions, documents } = this.props;

        return (
            <div className="terms_and_conditions">
                {isMobile && (
                    <header className="view-header header-simple">
                        <h1 className="text-center">
                            <I18n id="login.step6.header" />
                        </h1>
                    </header>
                )}
                <Notification scopeToShow="loginStep6" />
                <MainContainer className={classNames("onboarding")}>
                    {isDesktop && (
                        <h1 className="text-center">
                            <I18n id="login.step6.header" />
                        </h1>
                    )}
                    <Step6Content
                        isDesktop={isDesktop}
                        onCancel={this.onCancel}
                        commissions={commissions.body}
                        fileName={documents[0]?.fileNameKey}
                    />
                </MainContainer>
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
    commissions: loginSelectors.getCommissions(state),
    documents: settingsSelectors.getDocuments(state),
});
export default connect(mapStateToProps)(LoginStep6);
